import { useUserListQuery } from '@repo/lib';
import { UserListItem } from '@repo/types';
import { useDebounce } from '@uidotdev/usehooks';
import { useCallback, useState } from 'react';

export const useUserList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState<UserListItem | null>(null);

  // Debounce search term to avoid making too many API calls
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  // Use the React Query hook to fetch users
  const { users, isLoading, error } = useUserListQuery(debouncedSearchTerm);

  // Handle search term change
  const handleSearchChange = useCallback((term: string) => {
    setSearchTerm(term);
  }, []);

  // Handle user selection
  const handleSelectUser = useCallback((user: UserListItem) => {
    setSelectedUser(user);
    setSearchTerm(user.email);
  }, []);

  // Clear selection
  const handleClearSelection = useCallback(() => {
    setSelectedUser(null);
    setSearchTerm('');
  }, []);

  return {
    error,
    handleClearSelection,
    handleSearchChange,
    handleSelectUser,
    isLoading,
    searchTerm,
    selectedUser,
    users,
  };
};
